import { stepName as initialStepName } from '../../../components/process/generic/SimCard/SubstituteSimCard/SelectSimCardType'
import { getProvider } from '@/apollo'
import gql from 'graphql-tag'
import { splitError } from '@/helper/splitError'

const initialState = {
  working: false,
  step: initialStepName,
  simCardType: 'COMBI'
}

const SubstituteSimCardModule = {
  namespaced: true,
  state: initialState,
  actions: {
    async requestSubstituteSimCard ({ commit, state, getters, rootGetters }, { simCardType, nextStep }) {
      const apolloClient = getProvider().defaultClient
      commit('clearMessages', {}, { root: true })
      state.working = true

      return apolloClient.mutate({
        mutation: gql`mutation substituteSimCard ($substituteSimCardInput: SubstituteSimCardInput!) {
          substituteSimCard (substituteSimCardInput: $substituteSimCardInput) {
            success
          }
        }`,
        variables: {
          substituteSimCardInput: {
            type: simCardType
          }
        }
      }).then((response) => {
        state.working = false
        state.step = nextStep
      }).catch((error) => {
        splitError(error).forEach(e => commit('addError', e, { root: true }))
        state.working = false
      })
    }
  },
  mutations: {
    reset (state) {
      Object.assign(state, initialState)
    },
    changeStep (state, { step }) {
      state.step = step
    },
    setSimCardType (state, { simCardType }) {
      state.simCardType = simCardType
    }
  },
  getters: {
    currentStep: state => state.step,
    simCardType: state => state.simCardType,
    isWorking: state => state.working
  }
}

export {
  SubstituteSimCardModule
}
